import React from 'react';
import { Box, Typography, TextField, Paper } from '@mui/material';
import { alpha } from '@mui/material/styles';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const BookingMessage = ({ value, onChange }) => {
  return (
    <Box sx={{ 
      p: 4, 
      borderRadius: '24px', 
      bgcolor: 'white', 
      border: 1, borderColor: 'sutil' 
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
        <Box sx={{ 
          width: 36, 
          height: 36, 
          borderRadius: '10px', 
          bgcolor: (t) => alpha(t.palette.secondary.main, 0.1), 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          color: 'primary.main'
        }}>
          <ChatBubbleOutlineIcon fontSize="small" />
        </Box>
        <Typography variant="h6" fontWeight="900" color="primary.main">
          Mensaje o nota para el proveedor <Typography component="span" variant="inherit" color="text.secondary" sx={{ fontWeight: 500 }}>(Opcional)</Typography>
        </Typography>
      </Box>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontWeight: 500, ml: 6.5 }}>
        Añade especificaciones, requerimientos especiales o contexto útil para tu servicio.
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={4}
        placeholder="Ej. Tengo intolerancia al gluten, requiero adaptar la sesión..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '16px',
            bgcolor: 'grey.50',
            '& fieldset': { borderColor: 'divider' },
            '&:hover fieldset': { borderColor: 'secondary.main' },
            '&.Mui-focused fieldset': { borderColor: 'secondary.main' }
          }
        }}
      />
    </Box>
  );
};

export default BookingMessage;
